import React from "react";
import Box from "@mui/material/Box";

import {DeskingPage} from "../DeskingPage/DeskingPage";
import {DeskingContextProvider} from "../../contexts/DeskingContext";
import {BaseModal} from "../../components/BaseModal";
import {useMediaQuery} from "react-responsive";

// On a phone the desking panel goes full-screen, so the BaseModal wrapper must
// NOT apply its default top:50%/translate centering (that pushes the panel's top
// edge to mid-screen). Pin the wrapper to the top-left instead; #DeskingPage
// (≤768px) handles the rest of the full-screen layout.
const phoneModalStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'none',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none',
}


export const DeskingModal = ( { id, isOpen, setIsOpen, ...props } ) => {
    const isPhone = useMediaQuery({ query: '(max-width: 768px)' })
    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            style={isPhone ? phoneModalStyle : undefined}
        >
            <Box className={'DeskingModal'}>
                <DeskingContextProvider {...props}>
                    <DeskingPage
                        id={id}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        {...props}
                    />
                </DeskingContextProvider>
            </Box>
        </BaseModal>
    )
}